<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="total"
        :options.sync="options"
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, 200, 500] }"
        :show-select="allowMassSign"
        v-model="selectedItems"
        class="elevation-12"
        dense
    >
      <template v-slot:top>
        <div class="px-4">
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field
                  :label="$t('adminMailsDataTable.filters.mailIdentifier')"
                  v-model="filters.uid"
                  :clearable="true"
                  @change="onFiltersChanged"
              />
            </v-col>
            <v-col v-if="allowedPage" cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.inn"
                              :items="organizations"
                              :label="$t('common.labels.organization')"
                              :clearable="true"
                              item-text="name"
                              item-value="inn"
                              @change="loadUnits"
              />
            </v-col>
            <v-col v-if="allowedUnitPage && $store.getters.appLogin.unit && $store.getters.appLogin.unit.isHead" cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.unitId"
                              :items="units"
                              :label="$t('common.labels.department')"
                              :clearable="true"
                              item-text="name"
                              item-value="id"
                              @change="onFiltersChanged"
              />
            </v-col>
            <v-col else-if="allowedUnitPage && $store.getters.appLogin.globalunit && $store.getters.appLogin.globalunit.isHead" cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.unitId"
                              :items="units"
                              :label="$t('common.labels.department')"
                              :clearable="true"
                              item-text="name"
                              item-value="id"
                              @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.users"
                              :items="users"
                              :label="$t('mailsDataTable.filters.users')"
                              :clearable="true"
                              item-text="name"
                              item-value="id"
                              @change="onFiltersChanged"
                              multiple
                              small-chips
                              deletable-chips
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field
                  :label="$t('adminMailsDataTable.filters.receiver')"
                  v-model="filters.receiver"
                  :clearable="true"
                  @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.region"
                              :items="$store.getters.appRegions"
                              :item-value="item => item"
                              :item-text="item => item.name"
                              :label="$t('adminMailsDataTable.filters.region')"
                              :clearable="true"
                              @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.area"
                              :items="$store.getters.appAreas"
                              :item-value="item => item"
                              :item-text="item => item.name"
                              :label="$t('adminMailsDataTable.filters.district')"
                              :clearable="true"
                              @change="onFiltersChanged"
              />
            </v-col>
            <v-col v-if="!allowedUnitPage" cols="12" sm="6" md="3" lg="3">
              <v-menu
                  v-model="filterCreationStartMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      :label="$t('mailsDataTable.filters.creationStartDate')"
                      v-model="filterCreationStartDisplayValue"
                      readonly
                      v-on="on"
                      :clearable="true"
                      @input="onChangefilterCreationStartDisplayValue"
                  />
                </template>
                <v-date-picker
                    v-model="filters.start"
                    @change="onFilterStartChanged"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                />
              </v-menu>
            </v-col>
            <v-col v-if="!allowedUnitPage" cols="12" sm="6" md="3" lg="3">
              <v-menu
                  v-model="filterCreationEndMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      :label="$t('mailsDataTable.filters.creationEndDate')"
                      v-model="filterCreationEndDisplayValue"
                      readonly
                      v-on="on"
                      :clearable="true"
                      @input="onChangefilterCreationEndDisplayValue"
                  />
                </template>
                <v-date-picker
                    v-model="filters.end"
                    @change="onFilterEndChanged"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                />
              </v-menu>
            </v-col>
            <v-col v-if="allowedUnitPage" cols="12" sm="6" md="3" lg="3">
              <v-menu
                  v-model="filterSendStartMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      :label="$t('adminMailsDataTable.filters.dispatchStartDate')"
                      v-model="filterSendStartDisplayValue"
                      readonly
                      v-on="on"
                      :clearable="true"
                      @input="onChangefilterSendStartDisplayValue"
                  />
                </template>
                <v-date-picker
                    v-model="filters.sendFrom"
                    @change="onFilterSendStartChanged"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                />
              </v-menu>
            </v-col>
            <v-col v-if="allowedUnitPage" cols="12" sm="6" md="3" lg="3">
              <v-menu
                  v-model="filterSendEndMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      :label="$t('adminMailsDataTable.filters.dispatchEndDate')"
                      v-model="filterSendEndDisplayValue"
                      readonly
                      v-on="on"
                      :clearable="true"
                      @input="onChangefilterSendEndDisplayValue"
                  />
                </template>
                <v-date-picker
                    v-model="filters.sendEnd"
                    @change="onFilterSendEndChanged"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-select v-if="allowedUnitPage" v-model="customFilters.perform"
                        :items="performTypeFilterOptions"
                        :clearable="true"
                        :label="$t('adminMailsDataTable.filters.status')"
                        @change="onCustomPerformFilterChanged"
              >
              </v-select>
              <v-select v-if="allowMassSign" v-model="filters.sendStatus"
                        :items="statusOptions"
                        :clearable="true"
                        :label="$t('adminMailsDataTable.filters.status')"
                        @change="onCustomPerformFilterChanged"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="text-right">
              <v-btn v-if="allowedUnitPage" large color="warning" class="me-2" dark @click="onExcelButtonClicked">{{ $t('adminMailsDataTable.actions.toExcel') }}</v-btn>
              <v-btn x-large color="primary" dark @click="onRefreshButtonClicked">{{ $t('adminMailsDataTable.actions.update') }}</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="allowMassSign" cols="6" sm="12" md="6" lg="6">
              <v-btn color="primary" :disabled="disableSendButton" @click="onSendClicked">{{ $t('mailsDataTable.actions.send') }}</v-btn>
            </v-col>
            <v-col v-if="allowMassDelete" cols="6" sm="12" md="6" lg="6" class="text-right">
              <v-btn color="primary" :disabled="disableDeleteButton" @click="onDeleteClicked">{{ $t('mailsDataTable.actions.delete') }}</v-btn>
            </v-col>
          </v-row>
          <v-dialog v-model="deleteMailDialog" :persistent="true" max-width="600px">
            <v-card>
              <v-card-title class="headline justify-center">{{ $t('mailsDataTable.deleteDialog.title') }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDeleteMailDialog">{{ $t('common.actions.cancel') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1"  text @click="deleteItemConfirm">{{ $t('mailsDataTable.deleteDialog.deleteBtn') }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>

      <template v-slot:item.id="scope">
        <v-btn color="primary" text :to="{name: 'track', params: {uid: `EHM${scope.item.id}`}}">{{
            `EHM${scope.item.id}`
          }}
        </v-btn>
      </template>
      <template v-slot:item.creatorUser.unit.name="scope">
        <template v-if="$store.getters.isAdmin">
          {{ scope.item.creatorUser.unit.name }}
        </template>
        <template v-else>
          <router-link :to="{name: 'mail-view', params: {id: scope.item.id}}">{{ scope.item.creatorUser.unit.name }}</router-link>
        </template>
      </template>
      <template v-slot:item.receiver="scope">
        <template v-if="$store.getters.isAdmin">
          {{ scope.item.receiver }}
        </template>
        <template v-else>
          <router-link :to="{name: 'mail-view', params: {id: scope.item.id}}">{{ scope.item.receiver }}</router-link>
        </template>
      </template>
      <template v-slot:item.region="scope">
        {{ scope.item.region.name }}
      </template>
      <template v-slot:item.area="scope">
        {{ scope.item.area.name }}
      </template>
      <template v-slot:item.recipient="scope">
        {{ scope.item.perform.recipient }}
      </template>
      <template v-slot:item.createdOn="scope">
        {{ scope.item.createdOn.format('DD.MM.YYYY HH:mm:ss') }}
      </template>
      <template v-slot:item.sentOn="scope">
        <template v-if="scope.item.sentOn">
          {{ scope.item.sentOn.format('DD.MM.YYYY HH:mm:ss') }}
        </template>
      </template>
      <template v-slot:item.state="scope">
        <template v-if="scope.item.isSent">
          <template v-if="scope.item.perform">
            {{ scope.item.perform.performType.name }}
          </template>
          <template v-else>
            {{ $t('adminMailsDataTable.states.inProcess') }}
          </template>
        </template>
        <template v-else-if="scope.item.sendStatus === 0">
          {{ $t('mailsDataTable.states.sending') }}
        </template>
        <template v-else-if="scope.item.sendStatus === 1">
          {{ $t('mailsDataTable.states.successful') }}
        </template>
        <template v-else-if="scope.item.sendStatus === 2">
          {{ $t('mailsDataTable.states.postError') }}
        </template>
        <template v-else-if="scope.item.sendStatus === 3">
          {{ $t('mailsDataTable.states.mailError') }}
        </template>
        <template v-else-if="scope.item.sendStatus === 4">
          {{ $t('mailsDataTable.states.serverError') }}
        </template>
        <template v-else>
          {{ $t('adminMailsDataTable.states.notSent') }}
        </template>
      </template>
      <template v-slot:item.performDate="scope">
        <template v-if="scope.item.perform">
          {{ scope.item.perform.performedOn.format('DD.MM.YYYY') }}
        </template>
      </template>
      <template v-slot:no-data>
        {{ $t('adminMailsDataTable.noMailsFound') }}
      </template>
    </v-data-table>

    <template>
      <template v-if="isDeleteMailSuccess">
        <v-snackbar v-model="isDeleteMailSuccess"
                    :timeout="5000"
                    color="success"
        >
          <v-layout align-center pr-4>
            <v-layout column>
              <div>
                <strong>{{ $t('adminMailsDataTable.messages.deleteSuccess') }}</strong>
              </div>
            </v-layout>
          </v-layout>
        </v-snackbar>
      </template>
      <template v-else>
        <v-snackbar v-model="isDeleteMailSuccess"
                    :timeout="5000"
                    color="error"
        >
          <v-layout align-center pr-4>
            <v-layout column>
              <div>
                <strong>{{ $t('adminMailsDataTable.messages.deleteError') }}</strong>
              </div>
            </v-layout>
          </v-layout>
        </v-snackbar>
      </template>
    </template>

    <v-progress-linear
        v-if="massSendingInProgress"
        :indeterminate="true"
        :bottom="true"
        v-model="massSignItems.completedItemsCount"
        color="blue"
        height="50"
        striped
    >
      <template v-slot:default="{ value }">
        <strong>{{ value }} </strong>
      </template>
    </v-progress-linear>

    <v-snackbar v-if="showSnackbar"
                v-model="massSendCompleted"
                :timeout="20000"
                :bottom="true"
                color="info"
    >
      <div class="d-flex justify-space-around">
        <div class="font-weight-bold">{{ $t('mailsDataTable.progressSnackbar.success') }}: {{ this.massSignItems.successSignedItems }}</div>
        <div class="font-weight-bold"> |</div>
        <div class="font-weight-bold">{{ $t('mailsDataTable.progressSnackbar.failed') }}: {{ this.massSignItems.failedSignedItems }}</div>
        <div>
          <v-btn class="ml-auto" icon small right @click="onCloseSnackbarClicked">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-snackbar>


    <v-snackbar v-model="isUnitNotActive"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('mailsDataTable.messages.debtError') }}
    </v-snackbar>

    <v-snackbar v-model="isContractDateExpired"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('mailsDataTable.messages.contractExpiredError') }}
    </v-snackbar>

    <v-dialog v-model="sendDialog" :persistent="true" width="600px">
      <MassSignComponent
          @sign-clicked="onSign"
          @cancel="onSendCancel"
          :hash-code="sendHashCode"
          :disable="loading"
          ref="massSignRef"
      />
    </v-dialog>

  </div>
</template>

<script>
import _ from 'underscore'
import Moment from 'moment'
import * as PerformTypes from '../../enums/perform.type'
import MailService from "@/services/mail.service";
import EImzo from "../../plugins/eimzo";
import {mapGetters} from "vuex";
import MassSignComponent from "../MassSignComponent";
import formatter from "../../plugins/formatter";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
// import BalanceService from "@/services/balance.service";
import OrganizationService from "@/services/organization.service";
import Mappers from "@/mappers";
import UnitService from "@/services/unit.service";
import UserService from "@/services/user.service";
import XLSX from "xlsx";
import Mapper from "@/mappers";

export default {
  name: "MailsDataTable",
  components: {
    MassSignComponent
  },
  props: {
    mails: {
      type: Array,
      default: () => {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowMassSign: {
      type: Boolean,
      default: false
    },
    allowMassDelete: {
      type: Boolean,
      default: false
    },
    allowedPage: {
      type: Boolean,
      default: false
    },
    allowedUnitPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSnackbar: false,
      sendDialog: false,
      sendHashCode: '',
      isUnitNotActive: false,
      isContractDateExpired: false,

      customFilters: {
        perform: null
      },

      options: {
        sortBy: ['createdOn'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 50,
      },
      filters: {
        inn: null,
        unitId: null,
        region: null,
        area: null,
        start: null,
        end: null,
        sendFrom: null,
        sendEnd: null,
        performType: null,
        isPerformed: null,
        users: [],
        isExcel: false,
        sendStatus: null
      },
      filterCreationStartMenu: false,
      filterCreationEndMenu: false,
      filterCreationStartDisplayValue: '',
      filterCreationEndDisplayValue: '',
      filterSendStartMenu: false,
      filterSendEndMenu: false,
      filterSendStartDisplayValue: '',
      filterSendEndDisplayValue: '',

      currentItem: null,
      deleteMailDialog: false,
      isDeleteMailSuccess: false,

      organizations: [],
      units: [],
      users: [],
      selectedItems: [],
      massSendingInProgress: false,
      massSendCompleted: false,
      signFailed: false,

      massSignItems: {
        completedItemsCount: 0,
        successSignedItems: 0,
        failedSignedItems: 0,
      },
      certificate: null,
    };
  },
  computed: {
    ...mapGetters({
      activatedCertificate: "certificate"
    }),
    statusOptions() {
      return [
        { text: this.$t('mailsDataTable.statusOptions.notSent'), value: 100 },
        { text: this.$t('mailsDataTable.statusOptions.sending'), value: 0 },
        { text: this.$t('mailsDataTable.statusOptions.sent'), value: 1 },
        { text: this.$t('mailsDataTable.statusOptions.postError'), value: 2 },
        { text: this.$t('mailsDataTable.statusOptions.mailError'), value: 3 },
        { text: this.$t('mailsDataTable.statusOptions.serverError'), value: 4 },
      ]
    },
    disableSendButton() {
        console.log(this.selectedItems);
        return this.selectedItems.length <= 0 || this.selectedItems.some(item => item.sendStatus === 1 || item.sendStatus === 0);
    },
    disableDeleteButton() {
        return this.selectedItems.length <= 0 || this.selectedItems.some(item => item.sendStatus === 1 || item.sendStatus === 0);
    },
    performTypeFilterOptions() {
      const options = []
      _.each(PerformTypes, performType => {
        options.push({
          text: performType.name,
          value: performType
        })
      })

      return options
    },
    items() {
      let number = 1;
      let skip = this.skip;
      return _.map(this.mails, m => {
        m.displayNumber = skip + (number++)
        return m
      })
    },
    headers() {
      const headers = [];

      headers.push({
        text: this.$t('tableHeaders3.number'),
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })

      headers.push({
        text: this.$t('common.labels.identifier'),
        align: 'center',
        sortable: false,
        value: 'id'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.sender'),
        align: 'left',
        sortable: false,
        value: 'creatorUser.unit.name'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.receiver'),
        align: 'left',
        sortable: false,
        value: 'receiver'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.region'),
        align: 'center',
        sortable: true,
        value: 'region'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.district'),
        align: 'center',
        sortable: true,
        value: 'area'
      })

      headers.push({
        text: this.$t('tableHeaders3.address'),
        align: 'left',
        sortable: false,
        value: 'address'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.recipient'),
        align: 'center',
        sortable: true,
        value: 'perform.recipient'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.pageCount'),
        align: 'center',
        sortable: false,
        value: 'pagesCount'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.creationDate'),
        align: 'center',
        sortable: true,
        value: 'createdOn'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.dispatchDate'),
        align: 'center',
        sortable: true,
        value: 'sentOn'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.status'),
        align: 'center',
        sortable: false,
        value: 'state'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.deliveryReturnDate'),
        align: 'center',
        sortable: false,
        value: 'performDate'
      })

      headers.push({
        text: '',
        align: 'center',
        sortable: false,
        value: 'actions'
      })

      return headers;
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    },
  },
  methods: {
    onExcelButtonClicked(){
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc} = this.options;
      const {uid, unitId, receiver, region, area, start, end, sendFrom, sendEnd, performType, isPerformed, users, sendStatus} = this.filters;
      
      const isSentPage = this.$route.path.includes('/sent');

      MailService.get({
        skip: 0,
        limit: this.total,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        unitId: unitId,
        uid: uid,
        receiver: receiver,
        region: region,
        area: area,
        createdStart: !isSentPage && start ? Moment(start, 'YYYY-MM-DD') : null,
    createdEnd: !isSentPage && end ? Moment(end, 'YYYY-MM-DD') : null,
        // old param before changes
        // createdStart: start ? Moment(start, 'YYYY-MM-DD') : null,
        // createdEnd: end ? Moment(end, 'YYYY-MM-DD') : null,
        sentStart: sendFrom ? Moment(sendFrom, 'YYYY-MM-DD') : null,
        sentEnd: sendEnd ? Moment(sendEnd, 'YYYY-MM-DD') : null,
        users: users ? (users.length > 0 ? users : []) : [],
        performType: performType,
        sendStatus: sendStatus,
        isPerformed: isPerformed,

        isSent: true
      })
          .then(response => {
            var mails = _.map(response.data.Records, mailViewModel => {
              return Mapper.mapMail(mailViewModel)
            })

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet([
              [
                this.$t('tableHeaders3.number'),
                this.$t('common.labels.identifier'),
                this.$t('adminMailsDataTable.table.sender'),
                this.$t('adminMailsDataTable.filters.receiver') + 'w',
                this.$t('adminMailsDataTable.filters.region'),
                this.$t('adminMailsDataTable.filters.district'),
                this.$t('tableHeaders3.address'),
                this.$t('adminMailsDataTable.table.recipient'),
                this.$t('tableHeaders3.pageCount'),
                this.$t('adminMailsDataTable.table.creationDate'),
                this.$t('adminMailsDataTable.table.dispatchDate'),
                this.$t('adminMailsDataTable.filters.status'),
                this.$t('adminMailsDataTable.table.deliveryReturnDate')
              ],
            ]);

            worksheet['!cols'] = [{ width: 10 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 20 }, { width: 25 }, { width: 20 }];
            worksheet['!rows'] = [{ hpx: 25 }];

            for (let i = 1; i <= 10; i++) {
              const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i - 1 });
              const cell = worksheet[cellAddress];
              if (!cell) continue;

              cell.s = {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
                fill: {
                  fgColor: { rgb: '4472C4' },
                },
                border: {
                  top: { style: 'thin', color: { rgb: '000000' } },
                  bottom: { style: 'thin', color: { rgb: '000000' } },
                  left: { style: 'thin', color: { rgb: '000000' } },
                  right: { style: 'thin', color: { rgb: '000000' } },
                },
              };
            }

            mails.forEach((item, index) => {
              const row = [
                index + 1,
                item.id ? item.id : '',
                item.creatorUser.unit ? item.creatorUser.unit.name : '',
                item.receiver ? item.receiver : '',
                item.region.name ? item.region.name : '',
                item.area.name ? item.area.name : '',
                item.address ? item.address : '',
                item.perform ? item.perform.recipient : '',
                item.pagesCount ? item.pagesCount : '',
                item.createdOn.toString() ? item.createdOn.toString() : '',
                item.sentOn ? item.sentOn.toString() : '',
                item.perform ? item.perform.performType.name : this.$t('adminMailsDataTable.states.notSent'),
                item.perform ? item.perform.createdOn.toString() : '',
              ];

              XLSX.utils.sheet_add_aoa(worksheet, [row], { origin: index + 1 });
            });

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'mails.xlsx');
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadOrganizations() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      OrganizationService.getOrganizations({})
          .then(response => {
            this.organizations = _.map(response.data.Records, o => {
              return Mappers.mapOrganization(o?.Organization)
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadUnits() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      var inn = this.filters.inn
      if(this.allowedPage){
        UnitService.getUnits({inn})
            .then(response => {
              this.units = _.map(response.data.Records, o => {
                return Mappers.mapUnit(o)
              })
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
      else {
        inn = this.$store.getters.inn
        UnitService.getUserUnits({inn})
            .then(response => {
              this.units = _.map(response.data, o => {
                return Mappers.mapUnit(o)
              })
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    loadUsers() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      var unitId = this.filters.unitId
      var inn = this.filters.inn
      if(this.allowedPage){
        UserService.getUsersDynamic({inn:inn, unitId: unitId})
            .then(response => {
              this.users = _.map(response.data, o => {
                return Mappers.mapUser(o)
              })
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
      else {
        inn = this.$store.getters.inn
        UserService.getUsersDynamic({inn:inn, unitId: unitId})
            .then(response => {
              this.users = _.map(response.data, o => {
                return Mappers.mapUser(o)
              })
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }


    },
    async onSign(certificate) {
      this.certificate = certificate
      const activatedCertificate = await EImzo.activate(this.certificate).then().catch(() => {
        this.signFailed = true
        this.$nextTick(() => {
          this.$refs.massSignRef.showFailDialog()
        })
      })

      if (activatedCertificate !== undefined) {
        this.$store.commit('setCertificate', activatedCertificate);
        this.sendDialog = false

        this.massSendingInProgress = true
        this.clearSnackbarValues()

        await this.$store.dispatch(LAYOUT_LOADING_START)

        for (const item of this.selectedItems) {
          const {data} = await MailService.getSendHashCode(item.id)
          const signResult = await EImzo.createPkcs7(data, activatedCertificate)

          await MailService.sendToQueue({id: item.id, signature: signResult.pkcs7})
              .then(() => {
                this.massSignItems.successSignedItems += 1;
              })
              .catch((e) => {
                this.massSignItems.failedSignedItems += 1
                console.log(e)
              })
              .finally(() => {
                this.massSignItems.completedItemsCount += 1
              })
        }

        // BalanceService.get({organizationId: this.$store.getters.appLogin.organization.id})
        //   .then((data) => {
        //     this.$store.commit('setBalance', data.data);
        //   })

        await this.$store.dispatch(LAYOUT_LOADING_STOP)
        this.onMassSignCompleted()
      }
    },

    onCloseSnackbarClicked() {
      this.clearSnackbarValues()
    },
    clearSnackbarValues() {
      this.massSignItems.completedItemsCount = 0
      this.massSignItems.successSignedItems = 0
      this.massSignItems.failedSignedItems = 0

      this.showSnackbar = false
    },
    onMassSignCompleted() {
      this.updateItems()

      this.showSnackbar = true
      this.massSendingInProgress = false
      this.massSendCompleted = true
    },
    clearSend() {
      this.sendDialog = false
      this.sendHashCode = ''
    },
    onSendCancel() {
      this.clearSend()
    },
    async onSendClicked() {
      this.isUnitNotActive = false
      this.isContractDateExpired = false
      try {
        const isActive = await MailService.checkOrganizationIsActive();
        if (!isActive) {
          this.isUnitNotActive = true;
          return;
        }
        this.sendDialog = true;
      } catch (error) {
        if (error.message === 'UserUnitIsActive') {
          this.isUnitNotActive = true;
        } else if (error.message === 'UnitContractDateExpired') {
          this.isContractDateExpired = true;
        } else {
          console.error(error);
        }
      }
    },

    onDeleteClicked() {
      this.deleteMailDialog = true
    },
    deleteItemConfirm() {
      this.deleteMultipleItems()
      this.deleteMailDialog = false
    },
    closeDeleteMailDialog() {
      this.deleteMailDialog = false
    },
    deleteSingleItem(id) {
      MailService.delete(id)
          .then(() => {
            this.isDeleteMailSuccess = true
          })
      this.updateItems();
    },
    deleteMultipleItems() {
      const selectedIds = this.selectedItems.map(mail => mail.id);
      MailService.deleteMany(selectedIds)
          .then(() => {
            this.isDeleteMailSuccess = true;
            this.updateItems();
          })
          .catch(error => {
            console.error('Error deleting mails:', error);
            this.isDeleteMailSuccess = false;
          });
    },
    updateItems() {
      this.loadUnits()
      this.loadUsers()
      this.$emit("update", this.options, this.filters)
      this.updateRouteQuery(this.options, this.filters, this.customFilters)
    },
    updateRouteQuery(options, filters, customFilters) {
      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {uid, receiver, region, area, start, end} = filters;
      const {perform} = customFilters

      let routeQuery = {}

      // options
      if (!sortBy) {
        this.options.sortBy = ['createdOn']
      }
      if (!sortDesc) {
        this.options.sortDesc = [true]
      }
      if (!page) {
        this.options.page = 1
      }
      if (!itemsPerPage) {
        this.options.itemsPerPage = 50
      }

      routeQuery.sortBy = sortBy?.length === 1 ? sortBy[0] : sortBy
      routeQuery.sortDesc = sortDesc?.length === 1 ? sortDesc[0] : sortDesc
      routeQuery.page = page ?? page
      routeQuery.itemsPerPage = itemsPerPage ?? itemsPerPage

      // filters
      if (region) {
        routeQuery.region = region._id
      }
      if (area) {
        routeQuery.area = area._id
      }
      if (uid) {
        routeQuery.uid = uid
      }
      if (receiver) {
        routeQuery.receiver = receiver
      }
      if (perform) {
        routeQuery.perform = perform._id
      }
      if (start) {
        routeQuery.start = start
      }
      if (end) {
        routeQuery.end = end
      }

      this.$router.push({name: this.$route.name, query: routeQuery}).catch(error => {
        console.log(error)
      })
    },


    onFiltersChanged() {
      this.saveFiltersToLocalStorage();
      if (this.options.page !== 1)
        this.options.page = 1;
      else
        this.updateItems();
    },
    saveFiltersToLocalStorage() {
      const filtersToSave = {
        filters: this.filters,
        customFilters: this.customFilters,
      };
      localStorage.setItem('mail-filters', JSON.stringify(filtersToSave));
    },
    onRefreshButtonClicked() {
      this.updateItems();
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.filterCreationStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterCreationStartDisplayValue = ''
      }

      this.filterCreationStartMenu = false
      this.updateItems()
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.filterCreationEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterCreationEndDisplayValue = ''
      }

      this.filterCreationEndMenu = false
      this.updateItems()
    },
    onChangefilterCreationStartDisplayValue() {
      this.filters.start = null;
      this.updateItems()
    },
    onChangefilterCreationEndDisplayValue() {
      this.filters.end = null;
      this.updateItems()
    },
    onFilterSendStartChanged() {
      if (this.filters.sendFrom) {
        this.filterSendStartDisplayValue = Moment(this.filters.sendFrom, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterSendStartDisplayValue = ''
      }

      this.filterSendStartMenu = false
      this.updateItems()
    },
    onFilterSendEndChanged() {
      if (this.filters.sendEnd) {
        this.filterSendEndDisplayValue = Moment(this.filters.sendEnd, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterSendEndDisplayValue = ''
      }

      this.filterSendEndMenu = false
      this.updateItems()
    },
    onChangefilterSendStartDisplayValue() {
      this.filters.sendFrom = null;
      this.updateItems()
    },
    onChangefilterSendEndDisplayValue() {
      this.filters.sendEnd = null;
      this.updateItems()
    },
    onCustomPerformFilterChanged() {
      this.filters.performType = null
      this.filters.isPerformed = null

      if (this.customFilters.perform !== null && this.customFilters.perform !== undefined) {
        if (this.customFilters.perform._id === -2) {
          this.filters.isPerformed = false
        } else if (this.customFilters.perform._id === -1) {
          this.filters.isPerformed = true
        } else {
          this.filters.performType = this.customFilters.perform
        }
      }

      this.onFiltersChanged()
    }
  },
  created() {
    const savedFilters = localStorage.getItem('mail-filters');
    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);
      this.filters = Object.assign({}, this.filters, parsed.filters || {});
      this.customFilters = Object.assign({}, this.customFilters, parsed.customFilters || {});
    }
    if(this.allowedUnitPage){
      this.filters.sendFrom = Moment().format('YYYY-MM-DD');
      this.filters.sendEnd = Moment().format('YYYY-MM-DD');
      this.filterSendStartDisplayValue = Moment(this.filters.sendFrom, 'YYYY-MM-DD').format('DD.MM.YYYY')
      this.filterSendEndDisplayValue = Moment(this.filters.sendEnd, 'YYYY-MM-DD').format('DD.MM.YYYY')
    }
    else {
      this.filters.start = Moment().format('YYYY-MM-DD');
      this.filters.end = Moment().format('YYYY-MM-DD');
      this.filterCreationStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      this.filterCreationEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
    }


    if (this.$route.query) {
      // options
      if (this.$route.query.sortBy) {
        this.options.sortBy = []
        const sortBy = this.$route.query.sortBy
        this.options.sortBy.push(sortBy)
      }
      if (this.$route.query.sortDesc) {
        this.options.sortDesc = []
        let val = formatter.stringToBoolean(this.$route.query.sortDesc)
        this.options.sortDesc.push(val)
      }
      if (this.$route.query.page) {
        this.options.page = formatter.stringToNumber(this.$route.query.page)
      }
      if (this.$route.query.itemsPerPage) {
        this.options.itemsPerPage = formatter.stringToNumber(this.$route.query.itemsPerPage)
      }

      // filters
      if (this.$route.query.region) {
        this.filters.region = _.find(this.$store.getters.appRegions, r => {
          return r.id === formatter.stringToNumber(this.$route.query.region)
        })
      }
      if (this.$route.query.area) {
        this.filters.area = _.find(this.$store.getters.appAreas, a => {
          return a.id === formatter.stringToNumber(this.$route.query.area)
        })
      }
      if (this.$route.query.uid) {
        this.filters.uid = this.$route.query.uid
      }
      if (this.$route.query.receiver) {
        this.filters.receiver = this.$route.query.receiver
      }
      if (this.$route.query.start) {
        this.filters.start = this.$route.query.start
        this.filterCreationStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }
      if (this.$route.query.end) {
        this.filters.end = this.$route.query.end
        this.filterCreationEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }
      if (this.$route.query.perform) {
        this.customFilters.perform = _.find(PerformTypes, p => {
          return p._id === formatter.stringToNumber(this.$route.query.perform)
        })
        this.onCustomPerformFilterChanged()
      }
      if(this.allowedPage){
        this.loadOrganizations()
      }
      if(this.allowedUnitPage){
        this.loadUnits()
      }
      this.loadUsers()
    }
  },
  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    }
  }
}
</script>

<style scoped>

</style>